import { render, staticRenderFns } from "./expresstotal.vue?vue&type=template&id=0dbaab2e&scoped=true&"
import script from "./expresstotal.vue?vue&type=script&lang=js&"
export * from "./expresstotal.vue?vue&type=script&lang=js&"
import style0 from "./expresstotal.vue?vue&type=style&index=0&id=0dbaab2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbaab2e",
  null
  
)

export default component.exports